import { render } from "./PageNotFoundView.vue?vue&type=template&id=73d6b456&scoped=true"
import script from "./PageNotFoundView.vue?vue&type=script&lang=js"
export * from "./PageNotFoundView.vue?vue&type=script&lang=js"

import "./PageNotFoundView.vue?vue&type=style&index=0&id=73d6b456&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d6b456"]])

export default __exports__